export default "__VITE_ASSET__CeQukrij__"